if(typeof FN == 'undefined') FN = {};


FN.videoAutoplayerConfig = {};


FN.videoAutoplayer = {
  _observer: null,

  init: function(){
    if ('IntersectionObserver' in window) {
      FN.videoAutoplayer._observer = new IntersectionObserver(
        FN.videoAutoplayer._onIntersection,
        { threshold: 0.4 }
      );
      FN.videoAutoplayer.observeAll();
    } else {
      // fallback for browsers without IntersectionObserver
      FN.videoAutoplayer.playOrPauseAllVideos();
      $(window).on('scroll', FN.videoAutoplayer.playOrPauseAllVideos);
    }
  },

  /********************
  * (Re-)observe all videos currently in the DOM.
  * Call after any dynamic DOM change that adds or replaces <video> elements.
  */
  observeAll: function(){
    if (!FN.videoAutoplayer._observer) return;
    FN.videoAutoplayer._observer.disconnect();
    $('video').each(function(i, video){
      FN.videoAutoplayer._observer.observe(video);
    });
  },

  _onIntersection: function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        // guard against non-active rotator slides (opacity:0 in CSS)
        if (FN.videoAutoplayer.isVideoVisible(entry.target)) {
          FN.videoAutoplayer.startPlayback(entry.target);
        }
      } else {
        FN.videoAutoplayer.stopPlayback(entry.target);
      }
    });
  },

  /********************
  * Iterate through all videos on the page and
  * play or pause them depending on their visibility.
  * Used as the scroll-based fallback path.
  */
  playOrPauseAllVideos: function(){
    $('video').each(function(i, item){
      var isVideoVisible = FN.videoAutoplayer.isVideoVisible(item);
      FN.videoAutoplayer.playOrPause(item, isVideoVisible);
    });
  },

  /********************
  * Returns true if the given video item is both
  * visible in the viewport and visible through CSS
  */
  isVideoVisible: function(item){
    // is the video currently visible on the page / viewport?
    var visibleInViewport = FN.helpers.isVisibleInViewport({element: item, minimumVisiblePercent:40});
    // is the video currently visible by CSS properties (note that we have to check the _parent_ element)
    var visibleInCSS = $(item).parent().css(['opacity', 'visibility', 'display']);

    if(visibleInViewport && visibleInCSS.opacity > 0 && visibleInCSS.visibility != 'hidden' && visibleInCSS.display != 'none'){
      return true;
    }else{
      return false;
    }
  },

  playOrPause: function(item, isVideoVisible){
    if(isVideoVisible){
      FN.videoAutoplayer.startPlayback(item);
    }else{
      FN.videoAutoplayer.stopPlayback(item);
    }
  },

  startPlayback: function(videoElement) {
    var videoDomElement = $(videoElement).get(0);
    // with preload="none", trigger a load before playing so sources are resolved
    if (videoDomElement.preload === 'none' && videoDomElement.readyState === 0) {
      videoDomElement.load();
    }
    var isPlaying = videoDomElement.currentTime > 0 && !videoDomElement.paused && !videoDomElement.ended && videoDomElement.readyState > 2;
    if(!isPlaying){
      var playPromise = videoDomElement.play();
      if (playPromise !== undefined) {
        playPromise.then(function() {
          // Autoplay started!
        }).catch(function(error) {
          // Only show controls if autoplay was explicitly blocked by the browser.
          // AbortError is a transient interruption (e.g. load/play race), not a user-facing issue.
          if (error.name === 'NotAllowedError') {
            $(videoDomElement).prop('controls', true);
          }
        });
      }

      return true;
    }
  },

  stopPlayback: function(videoElement) {
    var videoDomElement = $(videoElement).get(0);
    var isPlaying = videoDomElement.currentTime > 0 && !videoDomElement.paused && !videoDomElement.ended && videoDomElement.readyState > 2;
    if(isPlaying){
      videoDomElement.pause();
      return true;
    }
  },

  rewindToStart: function(videoElement){
    var videoDomElement = $(videoElement).get(0);
    videoDomElement.currentTime = 0;
    return true;
  }
};



/********************
* --USAGE--
* Typically on pageReady, you'll simply want to call "init()" on the videoAutoplayer as follows:
*--------------------

$(document).ready(function(){
  FN.videoAutoplayer.init();
});

**********************/
